import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/rotate.svg'


const _withScopeId = n => (_pushScopeId("data-v-5bb36f68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bus-stop-container" }
const _hoisted_2 = {
  class: "title",
  id: "bus-stop-list-title"
}
const _hoisted_3 = { class: "right-btns-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "새로고침"
}, null, -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  role: "region",
  "aria-labelledby": "bus-stop-list-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString($setup.headerTitle), 1 /* TEXT */),
      ($setup.selectComplete)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-station-reset",
            onClick: $setup.resetSelectedBusStops
          }, " 정류장 재선택 "))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        _createCommentVNode(" 로그인을 했고, 사내셔틀 노선이 아닌 경우에만 화면 표출 "),
        ($setup.isLoggedIn && $props.shouldShowBusArrivalTimeSelect)
          ? (_openBlock(), _createBlock($setup["BusArrivalTimeSelect"], {
              key: 0,
              selectedOption: $props.selectedArrivalTimeOption,
              options: $props.arrivalTimeOptions,
              isAllocExisted: $setup.isAllocExisted,
              isInsideShuttle: $props.isInsideShuttle,
              onOnChangeOption: $setup.emitOnChangedArrivalTimeOption,
              onOnSelectPastTimeOption: $setup.emitOnSelectPastTimeOption
            }, null, 8 /* PROPS */, ["selectedOption", "options", "isAllocExisted", "isInsideShuttle"]))
          : _createCommentVNode("v-if", true),
        ($setup.isLoggedIn && $props.shouldShowBusLocations)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              ref: "refreshButton",
              class: "btn-refresh",
              onClick: $setup.updateBusLocation
            }, [..._hoisted_5], 512 /* NEED_PATCH */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode($setup["BusStopList"], {
        selectedArrivalTimeOption: $props.selectedArrivalTimeOption,
        busStops: $props.busStops,
        selectedBus: $props.selectedBus,
        arrivalTimesForDisplay: $props.arrivalTimesForDisplay,
        busLocations: $setup.busLocations,
        arrivalTimeOptionCode: $props.selectedArrivalTimeOption?.type,
        selectComplete: $setup.selectComplete,
        boardingBusStop: $setup.boardingBusStop,
        arrivalBusStop: $setup.arrivalBusStop,
        isInsideShuttle: $props.isInsideShuttle,
        isBackwardLine: $props.isBackwardLine,
        isBookable: $props.isBookable,
        allBusesMap: $props.allBusesMap,
        lineId: $props.lineId,
        turnId: $props.turnId,
        favoriteGetOnBusStop: $props.favoriteLine?.getOnBusStop,
        favoriteGetOffBusStop: $props.favoriteLine?.getOffBusStop,
        detourEndDtm: $props.detourEndDtm,
        shouldShowBusLocations: $props.shouldShowBusLocations,
        onToggleSelectBusStop: $setup.toggleSelectBusStop,
        onOnClickBusStopLocation: $setup.emitOnClickBusStopLocation,
        onOnClickScheduleBtn: $setup.emitOnClickScheduleBtn,
        onOnClickBubble: $setup.emitOnClickBubble,
        onOnClickBusIcon: $setup.emitOnClickBusIcon,
        onOnClickFavoriteStatusButton: $setup.emitOnClickFavoriteStatusButton
      }, null, 8 /* PROPS */, ["selectedArrivalTimeOption", "busStops", "selectedBus", "arrivalTimesForDisplay", "busLocations", "arrivalTimeOptionCode", "selectComplete", "boardingBusStop", "arrivalBusStop", "isInsideShuttle", "isBackwardLine", "isBookable", "allBusesMap", "lineId", "turnId", "favoriteGetOnBusStop", "favoriteGetOffBusStop", "detourEndDtm", "shouldShowBusLocations"])
    ])
  ]))
}